import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/www/wwwroot/dmt-courtbook/node_modules/next/dist/client/app-dir/link.js");
